import { render, staticRenderFns } from "./roam.vue?vue&type=template&id=465ba19f&scoped=true&"
import script from "./roam.vue?vue&type=script&lang=js&"
export * from "./roam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ba19f",
  null
  
)

export default component.exports